module.exports = __webpack_public_path__ + "img/IN-round.ac2a221e.png";